import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LangContext";

export const Process = () => {
  const { t } = useLang();
  const steps = t("process.steps");

  return (
    <section
      id="ablauf"
      data-testid="section-process"
      className="relative py-24 lg:py-32 bg-black"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-3xl mb-20">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-primary-red" />
            <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-zinc-400">
              {t("process.eyebrow")}
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight">
            {t("process.title")}
          </h2>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-6 sm:left-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-transparent via-white/15 to-transparent sm:-translate-x-1/2" />

          <div className="space-y-14 lg:space-y-20">
            {steps.map((s, i) => {
              const isLeft = i % 2 === 0;
              return (
                <motion.div
                  key={i}
                  data-testid={`process-step-${i}`}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.6, delay: 0.05 * i }}
                  className={`relative grid sm:grid-cols-2 gap-8 items-center ${
                    isLeft ? "" : "sm:[&>*:first-child]:order-2"
                  }`}
                >
                  <div className={`pl-16 sm:pl-0 ${isLeft ? "sm:pr-16 sm:text-right" : "sm:pl-16"}`}>
                    <div
                      className={`inline-flex items-center gap-3 mb-3 ${
                        isLeft ? "sm:flex-row-reverse" : ""
                      }`}
                    >
                      <span className="font-display text-6xl lg:text-7xl font-black text-primary-red/30 leading-none">
                        {s.k}
                      </span>
                    </div>
                    <h3 className="font-display text-2xl lg:text-3xl font-semibold text-white tracking-tight mb-3">
                      {s.t}
                    </h3>
                    <p className="font-body text-sm lg:text-base text-zinc-400 leading-relaxed max-w-md sm:max-w-none">
                      {s.d}
                    </p>
                  </div>
                  <div className="hidden sm:block" />

                  {/* Node */}
                  <div className="absolute left-6 sm:left-1/2 top-6 -translate-x-1/2 z-10">
                    <div className="w-4 h-4 rounded-full bg-primary-red shadow-[0_0_25px_rgba(227,0,15,0.7)]" />
                    <div className="absolute inset-0 w-4 h-4 rounded-full bg-primary-red animate-ping opacity-40" />
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
